import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigateToPost } from "@/react/components/PostsV3/PostModal/hooks/useNavigateToPost";
import { usePostNavigationContext } from "@/react/components/PostsV3/PostViewList/PostNavigationContext";
import type { Notification } from "@circle-react/types/Notification";
import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const CommentNotification = ({
  notification,
  onClickHandler,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}) => {
  const { pathname } = useLocation();
  const isOnSamePage = notification.action_web_path?.includes(pathname);
  const { navigateToPost } = useNavigateToPost();
  const { params, hasNextPage } = usePostNavigationContext();

  if (isOnSamePage) {
    return (
      <a
        href={notification.action_web_path}
        onClick={onClickHandler}
        className="w-full"
      >
        <DefaultNotificationContent notification={notification} />
      </a>
    );
  }

  return (
    <Link to={notification.action_web_path}>
      <button
        type="button"
        onClick={(event: any) => {
          event.preventDefault();
          navigateToPost({
            pathname: notification.action_web_path,
            prevLocation: location as any,
            params,
            hasNextPage,
            shouldFocusOnCommentsSection: true,
            shouldDisableNavigation: true,
          });
          onClickHandler(event);
        }}
        className="w-full text-left"
      >
        <DefaultNotificationContent notification={notification} />
      </button>
    </Link>
  );
};
